import { Controller } from 'stimulus';

class Career extends Controller {

  connect() {
    const _this = this;
     
    _this.url = 'https://api.lever.co/v0/postings/unitedwayla?group=team&mode=json'

    const pageUrl = window.location.href;
    _this.leverParameter = '';
    const trackingPrefix = '?lever-'

    if( pageUrl.indexOf(trackingPrefix) >= 0){
      // Found Lever parameter
      const pageUrlSplit = pageUrl.split(trackingPrefix);
      _this.leverParameter = '?lever-'+pageUrlSplit[1];
    }

    $.ajax({
      dataType: "json",
      url: _this.url,
      success: (data) => {
        _this.loadingTarget.classList.add('hidden');
        _this.loadingTarget.classList.remove('visible');
        _this.createJobs(data);

        // _this.activateButtons(data);
      }
    })
  }

  //Functions for checking if the variable is unspecified
  cleanString(string) {
    if (string) {
      const cleanString = string.replace(/\s+/ig, "");
      return cleanString;
    }
    else {
      return "Uncategorized";
    }
  }

  nullCheck(string) {
    if (!string) {
      const result = 'Uncategorized'
      return result;
    }
    else { 
      return string;
    }
  }

  createJobs(_data) {
    // _data.forEach((job) => {
    //   const team = this.nullCheck(job.title)
    //   const teamCleanString = this.cleanString(team);
    //   $('#jobs-container .jobs-teams').append(
    //       '<a href="#" class="btn '+teamCleanString+'">'+team+'</a>'
    //     );
    // })

    _data.forEach((job) => {
      job.postings.forEach((posting) => {
        const title = posting.text
        
        const descEl = document.createElement('div');
        descEl.innerHTML = posting.description;

        const description = descEl.textContent;
        const descriptionFlag = "WHY WE NEED YOU";
        const descriptionStart = description.indexOf(descriptionFlag) !== -1 ? description.indexOf(descriptionFlag) + descriptionFlag.length + 1 : 0;
        const shortDescription = description.substring(descriptionStart, descriptionStart + 200).replace('\n', ' ') + "...";

        const locationPin = '<svg width="10" height="14" viewBox="0 0 10 14" fill="none" ><path d="M4.9 0C2.191 0 0 2.191 0 4.9C0 8.575 4.9 14 4.9 14C4.9 14 9.8 8.575 9.8 4.9C9.8 2.191 7.609 0 4.9 0ZM4.9 6.65C3.934 6.65 3.15 5.866 3.15 4.9C3.15 3.934 3.934 3.15 4.9 3.15C5.866 3.15 6.65 3.934 6.65 4.9C6.65 5.866 5.866 6.65 4.9 6.65Z" fill="#10167F"/></svg>';
        const location = this.nullCheck(posting.categories.location);
        const locationCleanString = this.cleanString(location);

        const commitment = this.nullCheck(posting.categories.commitment);
        const commitmentCleanString = this.cleanString(commitment);
  
        const team = this.nullCheck(posting.categories.team);
        const teamCleanString = this.cleanString(team);
  
        const link = posting.hostedUrl + this.leverParameter;

        $('#jobs-container .jobs-list').append(`
          <li class="card-results group card-results--job${' ' + teamCleanString}${' ' + locationCleanString}${' ' + commitmentCleanString}">
            <div class="card-results_copy !w-full">
              <a href="${ link }" target="_blank">
                <div class="headline headline-3 !mb-2">${title}</div>
              </a>
              <div class="card-results_copy--summary flex gap-y-2 gap-x-5 mb-2">
                <span class="font-bold">${commitment}</span> <span class="subtitle subtitle-2 flex items-baseline w-full gap-2">${locationPin} ${location}</span>
              </div>
              <div class="body body-3">${shortDescription}</div>
              <div>
                <a href="${link}" class="btn btn-stroke btn-uw-blue !flex items-center gap-2" target="_blank">
                  Learn More<span class="sr-only"> about the ${title} open position</span>
                  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.9 1H1.5C0.947715 1 0.5 1.44772 0.5 2V14C0.5 14.5523 0.947716 15 1.5 15H13.5C14.0523 15 14.5 14.5523 14.5 14V7.6" stroke="#10167F"/><path d="M15 1C15 0.723858 14.7761 0.5 14.5 0.5H10C9.72386 0.5 9.5 0.723858 9.5 1C9.5 1.27614 9.72386 1.5 10 1.5H14V5.5C14 5.77614 14.2239 6 14.5 6C14.7761 6 15 5.77614 15 5.5V1ZM2.85355 13.3536L14.8536 1.35355L14.1464 0.646447L2.14645 12.6464L2.85355 13.3536Z" fill="#10167F"/></svg>
                </a>
              </div> 
            </div>
          </li>`);
        });
    });
  }

  //Creating filter buttons for sorting your jobs
  // activateButtons(_data) {
  //   $('.jobs-teams').on("click", "a", (e) => {
  //     e.preventDefault();
  //     _data.forEach((teamObject) => {
  //       const teamRaw = teamObject.title;
  //       const team = this.cleanString(teamRaw);
  //       const jobs = $(".jobs-list");
  //       if ($(this).hasClass(team)) {
  //         if ($(this).hasClass("active")) { 
  //           $(this).removeClass("active");
  //           jobs.find(".job").fadeIn("fast");
  //         }
  //         else {
  //           $(".jobs-teams").find("a").removeClass("active");
  //           $(this).addClass("active");
  //           jobs.find("."+team).fadeIn("fast");
  //           jobs.find(".job").not("."+team).fadeOut("fast");
  //         }
  //       } 
  //     });
  //   })
  // }
}

Career.targets = ['postings', 'loading'];

export default Career;